import { useEffect, useRef } from "react";
import { useAppSelector } from "../../../../Redux/store";
import { KeyEvent } from "../../../../hooks/keyboardEventListener"
import { IElDimensions, ResizeEvent, postScreenSizeMessage } from "../../../../hooks/screenSize";
import { astercoinsGame } from "./Const/astercoins";

export type IButtonCodeChars = 'u' | 'r' | 'd' | 'l' | 'x' | 'z' | 's';
export type IButtonCodeInts = 1 | 2 | 3 | 4 | 5 | 6 | 0;

export interface IPostMessageParams {
    c?: IButtonCodeChars;
    i?: IButtonCodeInts;
    s?: IElDimensions;
    e: KeyEvent | ResizeEvent;
}

export const postGameMessage = (message: IPostMessageParams) => {
    const iframe = document.getElementById('iframe') as HTMLIFrameElement;
    if (iframe) {
        (document.getElementById('iframe') as HTMLIFrameElement)?.contentWindow?.postMessage(
            message,
            { targetOrigin: '*' }
        )
    }
};

export const Game = () => {
    const ref = useRef<HTMLIFrameElement>(null);
    const { gameUrl, demoGame } = useAppSelector(state => state.game);


    useEffect(() => {
        if (!ref.current) return;

        postGameMessage({
            e: 'rs',
            s: {
                h: ref.current.clientHeight,
                w: ref.current.clientWidth
            }
        })
    }, []);
    return (
        <iframe
            onLoadedData={() => console.log('onnLoadedData')}
            onCanPlay={() => console.log('onCanPlay')}
            ref={ref}
            id='iframe'
            className="bg-white h-full w-full block border-none m-0"
            title="demo"
            src={gameUrl.length > 1 ? gameUrl : `data:text/html,${astercoinsGame}`}
            onLoad={() => postScreenSizeMessage()}
        />
    )
}
